<template>
    <footer class="absolute bottom-0 left-0 right-0 h-16 text-center bg-indigo-700 text-gray-200 flex justify-center items-center z-10">
        Copyright © 2021 HiddenStorm.de
    </footer>
</template>